// extracted by mini-css-extract-plugin
module.exports = {"productList":"product-styles_productList__LUMMT","dashboardItem":"product-styles_dashboardItem__P1h6_"};